import { Action } from '@ngrx/store';

import { HideModalReason } from '®shared/modals';

export enum DeleteListActionTypes {
  DELETE_LIST_SHOW_MODAL = '[Delete list] Show modal',
  DELETE_LIST_HIDE_MODAL = '[Delete list] Hide modal',
  DELETE_LIST = '[Delete list] Delete list',
  DELETE_LIST_SUCCEEDED = '[Delete list] Delete list succeeded',
  DELETE_LIST_FAILED = '[Delete list] Delete list failed',
}

export interface DeleteListPayload {
  listId: string;
}

export class DeleteListShowModalAction implements Action {
  readonly type = DeleteListActionTypes.DELETE_LIST_SHOW_MODAL;

  constructor(public payload: DeleteListPayload) {}
}

export interface DeleteListHideModalPayload extends DeleteListPayload {
  reason: HideModalReason;
}

export class DeleteListHideModalAction implements Action {
  readonly type = DeleteListActionTypes.DELETE_LIST_HIDE_MODAL;

  constructor(public payload: DeleteListHideModalPayload) {}
}

export class DeleteListAction implements Action {
  readonly type = DeleteListActionTypes.DELETE_LIST;

  constructor(public payload: DeleteListPayload) {}
}

export class DeleteListSucceededAction implements Action {
  readonly type = DeleteListActionTypes.DELETE_LIST_SUCCEEDED;

  constructor(public payload: DeleteListPayload) {}
}

export interface DeleteListFailedPayload extends DeleteListPayload {
  error: any;
}

export class DeleteListFailedAction implements Action {
  readonly type = DeleteListActionTypes.DELETE_LIST_FAILED;

  constructor(public payload: DeleteListFailedPayload) {}
}

export type DeleteListActions =
  | DeleteListShowModalAction
  | DeleteListHideModalAction
  | DeleteListAction
  | DeleteListSucceededAction
  | DeleteListFailedAction;
